import { css } from 'linaria';

export const entranceDoorsHouseSectionTitle = css`
  && {
    position: relative;
    padding-bottom: 140px;

    &::before {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 80px;
      background-color: var(--secondary-green-light);
      border-radius: var(--rounding-l);
      content: '';
    }

    &::after {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 520px;
      height: 140px;
      background-image: url("https://cdn.lemanapro.ru/lmru/image/upload/q_90,f_auto,c_pad,b_auto/fudzi/elbrus/images/landings/entrance-doors-mf/house-section/background-d.png/background-d.png");
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
      content: '';
    }

    @media (--only-mobile) {
      padding-bottom: 128px;

      &::after {
        width: 288px;
        height: 104px;
        background-image: url("https://cdn.lemanapro.ru/lmru/image/upload/q_90,f_auto,c_pad,b_auto/fudzi/elbrus/images/landings/entrance-doors-mf/house-section/background-m.png/background-m.png");
      }
    }
  }
`;

export const entranceDoorsHouseSectionCard = css`
  && {
    background-color: var(--secondary-green-light);

    &:hover {
      background-color: var(--secondary-green-primary);
    }
  }
`;
